document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById('SizeChartModal');
  if (modal) {
    document.body.appendChild(modal);
  }

  // const openBtn = document.querySelector('[data-open-size-chart]');
  // const closeBtns = document.querySelectorAll('[data-close-size-chart]');

  // if (openBtn && modal) {
  //   openBtn.addEventListener('click', () => {
  //     modal.classList.remove('hidden');
  //     document.body.classList.add('overflow-hidden');
  //   });

  //   closeBtns.forEach(btn => {
  //     btn.addEventListener('click', () => {
  //       modal.classList.add('hidden');
  //       document.body.classList.remove('overflow-hidden');
  //     });
  //   });
  // }
});